export { BenefitsHero } from "./BenefitsHero";
